import { SearchOutlined } from '@ant-design/icons';
import { ISignUpFormData } from '@root/modules/Authentication/SignUp/interfaces';
import { placesAutocomplete } from '@root/utils/helpers/placesAutocomplete';
import {
  Button,
  Col,
  Form,
  Input,
  InputNumber,
  message,
  Row,
  Select
} from 'antd';
import React, {
  forwardRef,
  useEffect,
  useImperativeHandle,
  useMemo,
  useRef,
  useState
} from 'react';
import useOnclickOutside from 'react-cool-onclickoutside';
import { AutocompletePrediction } from 'react-places-autocomplete';
import { useLocation } from 'react-router-dom';
import usePlacesAutocomplete, {
  getGeocode,
  getLatLng
} from 'use-places-autocomplete';
import '../../../../../styles/pages/seller/_recipient.scss';
import { IRecipient } from '../../interface';
import { ProcessType } from '@root/modules/Sellers/Shipping/enum';

const { TextArea } = Input;
const { Option } = Select;
type importReturn = {
  productId: number;
  returnQuantity: number;
  nameInput?: string;
};

const Recipient = forwardRef((props: IRecipient, ref) => {
  const [coordinates, setCoordinates] = useState<{
    lat: number;
    lng: number;
  }>({
    lat: 0,
    lng: 0
  });
  const [form] = Form.useForm<ISignUpFormData>();
  const [searchValue, setSearchValue] = useState<string>('');
  const inputRef: any = useRef();
  const [processType, setProcessType] = useState<ProcessType>();
  const [productUse, setProductUse] = useState([] as any);

  useEffect(() => {
    setProductUse(props.product);
    form.resetFields();
    setSearchValue(props.detailReturnAddress ?? '');
  }, [props.product]);

  useEffect(() => {
    form.resetFields();
    setSearchValue('');
  }, [props.listCheckProduct]);
  useEffect(() => {
    form.resetFields();
    setSearchValue(props.detailReturnAddress ?? '');
    setTimeout(() => {
      if (props.onChange) {
        props.onChange(form);
      }
    }, 1000);
  }, [props.entityId, props.canEdit]);

  const {
    suggestions: { status, data },
    setValue,
    clearSuggestions
  } = usePlacesAutocomplete({
    debounce: 300
  });
  useImperativeHandle(ref, () => {
    return inputRef.current;
  });
  const refAddress = useOnclickOutside(() => {
    clearSuggestions();
  });
  const handleInput: React.ChangeEventHandler<HTMLInputElement> = (e) => {
    if (form.getFieldError('googleMapAddress').length === 0) {
      setCoordinates({
        lat: 0,
        lng: 0
      });
      form.setFieldsValue({
        postalCode: '',
        country: '',
        googleMapAddress: '',
        detailAddress: '',
        detailAddress2: '',
        streetNum: '',
        streetRoute: '',
        city: '',
        state: ''
      });
      setValue(e.target.value);
    } else {
      clearSuggestions();
    }
    setSearchValue(e.target.value);
  };

  const handleSelectAddr =
    ({ description }: AutocompletePrediction) =>
    async () => {
      setValue(description, false);
      clearSuggestions();

      const results = await getGeocode({ address: description });
      const { lat, lng } = getLatLng(results[0]);
      setCoordinates({
        lat,
        lng
      });
      setSearchValue(description);
      form.setFieldsValue({
        googleMapAddress: description
      });
      const address_components = results[0].address_components;
      const {
        COUNTRY,
        ZIP_CODE,
        TOWN,
        CITY,
        STATE,
        NEAREST_ROAD,
        STREET_NUMBER
      } = placesAutocomplete.getAddressComponent(address_components, [
        'COUNTRY',
        'TOWN',
        'CITY',
        'STATE',
        'ZIP_CODE',
        'NEAREST_ROAD'
      ]);

      form.setFieldsValue({
        detailAddress: results[0].formatted_address.split(',')[0]!,
        country: COUNTRY!,
        postalCode: ZIP_CODE!,
        state: STATE ?? CITY!,
        city: TOWN ?? CITY!,
        streetNum: STREET_NUMBER!,
        streetRoute: NEAREST_ROAD!
      });

      if (props.onChange) {
        props.onChange(form);
      }
    };

  const renderSuggestions = () =>
    data.map((suggestion: any) => {
      const {
        place_id,
        structured_formatting: { main_text, secondary_text }
      } = suggestion;
      return (
        <li key={place_id} onClick={handleSelectAddr(suggestion)}>
          <strong>{main_text}</strong> <small>{secondary_text}</small>
        </li>
      );
    });
  let getQuantity: importReturn[] = [];
  const onFinish = (values: any) => {
    if (props.tab === '1') {
      if (!!props.entityId === false) {
        message.error('Please search inbound number!');
      } else if (
        props.idPros.length === 0 ||
        props.idPros[0]?.checkedValues.length === 0
      ) {
        message.error('Please choose product');
      } else {
        let sss = productUse.filter((item: any) => {
          return props.idPros[0].checkedValues.includes(item.productId);
        });
        let ss = sss.map((item: any) => ({
          id: item.productId,
          quantity: item.value
        }));
        const bodyOrder = {
          entityId: props.entityId,
          orderProducts: ss,
          returnReason: values.reason,
          recipientName: values.recipientName,
          recipientPhone: values.recipientPhone,
          returnAddress: values.detailAddress,
          detailReturnAddress: values.detailAddress,
          detailReturnAddress2: values.detailAddress2,
          city: values.city,
          state: values.state,
          comment: values.sellerComment,
          returnType: 'Order',
          country: values.country,
          postalCode: values.postalCode,
          processType,
          quantity: 0
        };
        for (const name in bodyOrder) {
          if (bodyOrder.hasOwnProperty(name)) {
            if (processType === ProcessType.Return) {
              props.setOpenReject(true);
            } else {
              props.setOpenApprove(true);
            }
            props.getBody(bodyOrder);
          }
        }
      }
    } else if (props.tab === '2') {
      for (let i = 0; i < props.idArr.length; i++) {
        getQuantity.push({
          productId: props.idArr[i].productId,
          returnQuantity: values.quantity[i]
        });
      }
      if (props.entityId === false) {
        message.error('Please search inbound number!');
      } else if (props.idArr.length === 0) {
        message.error('Please choose product!');
      } else {
        const body = {
          entityId: props.entityId,
          returnReason: values.reason,
          recipientName: values.recipientName,
          recipientPhone: values.recipientPhone,
          returnAddress: values.googleMapAddress,
          comment: values.sellerComment,
          importReturn: getQuantity,
          detailReturnAddress: values.detailAddress,
          postalCode: values.postalCode,
          country: values.country,
          detailReturnAddress2: values.detailAddress2,
          city: values.city,
          state: values.state,
          returnType: 'Import',
          processType: processType
        };
        for (const name in body) {
          if (body.hasOwnProperty(name)) {
            if (processType === ProcessType.Return) {
              props.setOpenReject(true);
            } else {
              props.setOpenApprove(true);
            }
            props.getBody(body);
          }
        }
      }
    } else {
      if (!!props.entityId === false) {
        message.error('Please search inbound number!');
      } else {
        const bodyStock = {
          entityId: props.entityId,
          returnReason: values?.reason,
          recipientName: values.recipientName,
          recipientPhone: values.recipientPhone,
          returnAddress: values.detailAddress,
          detailReturnAddress: values.detailAddress,
          comment: values.sellerComment,
          returnType: 'Stock',
          country: values.country,
          postalCode: values.postalCode,
          detailReturnAddress2: values.detailAddress2,
          city: values.city,
          state: values.state,
          processType: processType,
          quantity: +values.quantity
        };
        for (const name in bodyStock) {
          if (bodyStock.hasOwnProperty(name)) {
            if (processType === ProcessType.Return) {
              props.setOpenReject(true);
            } else {
              props.setOpenApprove(true);
            }
            props.getBody(bodyStock);
          }
        }
      }
    }
  };

  const initialValues =  useMemo(() => ({
    recipientName: props.recipientName,
    recipientPhone: props.recipientPhone,
    shippingAddress: props.detailReturnAddress,
    sellerComment: props.sellerComment,
    street: props.street,
    state: props.state,
    city: props.city,
    postalCode: props.postalCode,
    statusReturn: props.statusReturn,
    warehouseReturnStatus: props.warehouseReturnStatus,
    returnReason: props.returnReason,
    detailAddress: props.detailReturnAddress,
    detailAddress2: props.detailReturnAddress2,
    quantity: props.quantity,
    country: props.country,
    reason: props.returnReason,
    googleMapAddress: props.detailReturnAddress
  }), [props]);

useEffect(() => {
  form.setFieldsValue(initialValues);
}, [initialValues]);

  return (
    <div className="recipient-wrapper">
      {props.canEdit ? (
        <Form
          form={form}
          layout="vertical"
          name="control-ref"
          ref={inputRef}
          onChange={() => {
            if (props.onChange) {
              props.onChange(form);
            }
          }}
          onFinish={onFinish}
          initialValues={initialValues}
        >
          <Row>
            <Col span={11}>
              <Row>
                <Col span={12} style={{ paddingRight: '10px' }}>
                  <Form.Item
                    label="Recipient Name"
                    name="recipientName"
                    className="recipient-name"
                    rules={[
                      {
                        required: true,
                        message: 'Please enter your name!'
                      }
                    ]}
                  >
                    <Input className="border-input" maxLength={20} />
                  </Form.Item>
                </Col>
                <Col span={12}>
                  <Form.Item
                    label="Recipient Phone Number"
                    name="recipientPhone"
                    className="recipient-name"
                    rules={[
                      {
                        pattern: new RegExp(/^[+-]?\d+(\.\d+)?$/),
                        message: 'Please input number'
                      },
                      {
                        required: true,
                        message: 'Please enter your phone!'
                      }
                    ]}
                  >
                    <Input className="border-input" maxLength={20} />
                  </Form.Item>
                </Col>
              </Row>
            </Col>
            <Col span={13}>
              <Row>
                <Col span={24} style={{ padding: '8px 0 8px' }}>
                  <span
                    style={{
                      marginRight: '4px',
                      color: '#ff4d4f',
                      fontSize: '11px'
                    }}
                  >
                    *
                  </span>
                  Shipping Country/Address
                </Col>
                <Col
                  span={6}
                  style={{
                    flex: '0 0 25%',
                    paddingLeft: '10px',
                    paddingRight: '10px'
                  }}
                >
                  <Form.Item
                    label=""
                    name="country"
                    className="recipient-name"
                    rules={[
                      {
                        required: true,
                        message: 'Please enter your country!'
                      }
                    ]}
                  >
                    <Input disabled />
                  </Form.Item>
                </Col>
                <>
                  <Col span={18}>
                    <Form.Item
                      className="recipient-name"
                      name="googleMapAddress"
                      label=""
                      rules={[
                        {
                          // required: true,
                          message: 'Please enter your address!'
                        }
                      ]}
                    >
                      <div ref={refAddress}>
                        <Input
                          className="border-input"
                          value={searchValue}
                          onChange={handleInput}
                          placeholder="Search Places ..."
                          suffix={<SearchOutlined />}
                        />
                        {status === 'OK' && <ul>{renderSuggestions()}</ul>}
                      </div>
                    </Form.Item>
                  </Col>
                </>
              </Row>
            </Col>
          </Row>
          <Row>
            <Col span={11} className="cmtArea">
              <div>
                <p style={{ display: 'flex', alignItems: 'center' }}>
                  <span
                    style={{
                      color: 'red',
                      fontSize: '20px',
                      marginRight: '5px'
                    }}
                  >
                    *
                  </span>
                  Comment from seller
                </p>
                <Form.Item
                  name="sellerComment"
                  className="recipient-name"
                  rules={[
                    {
                      required: true,
                      message: 'Please enter your comment!'
                    }
                  ]}
                >
                  <TextArea
                    rows={4}
                    style={{ resize: 'none' }}
                    maxLength={150}
                  />
                </Form.Item>
              </div>
            </Col>
            <Col span={13} style={{ paddingLeft: '10px' }}>
              <Row
                style={{
                  marginTop: '21px'
                }}
              >
                <Col span={12} style={{ paddingRight: '10px' }}>
                  <Form.Item
                    style={{
                      display: 'inline-block',
                      width: '100%',
                      borderRadius: '7px'
                    }}
                    name="detailAddress2"
                  >
                    <Input
                      className="border-input"
                      placeholder="More detail adress"
                    />
                  </Form.Item>
                </Col>
                <Col span={12}>
                  <Form.Item
                    style={{
                      display: 'inline-block',
                      width: '100%',
                      borderRadius: '7px'
                    }}
                    name="detailAddress"
                  >
                    <Input
                      className="border-input"
                      placeholder="Apartment, suite, unite, building, floor, etc."
                    />
                  </Form.Item>
                </Col>
                <Col
                  span={8}
                  style={{ paddingTop: '10px', paddingRight: '10px' }}
                >
                  <Form.Item
                    style={{
                      display: 'inline-block',
                      width: '100%',
                      borderRadius: '7px'
                    }}
                    name="city"
                  >
                    <Input className="border-input" placeholder="Town/City" />
                  </Form.Item>
                </Col>
                <Col
                  span={8}
                  style={{ paddingTop: '10px', paddingRight: '10px' }}
                >
                  <Form.Item
                    style={{
                      display: 'inline-block',
                      width: '100%',
                      borderRadius: '7px'
                    }}
                    name="state"
                  >
                    <Input
                      className="border-input"
                      placeholder="County/State"
                    />
                  </Form.Item>
                </Col>
                <Col span={8} style={{ paddingTop: '10px' }}>
                  <Form.Item
                    style={{
                      display: 'inline-block',
                      width: '100%',
                      borderRadius: '7px'
                    }}
                    name="postalCode"
                  >
                    <Input className="border-input" placeholder="Postal Code" />
                  </Form.Item>
                </Col>
              </Row>
              <Row style={{ gap: '10px' }}>
                {props.notQuan ? null : (
                  <Col span={8}>
                    {props.haveOneQuan ? (
                      <>
                        <Form.Item
                          label="Quantity"
                          name="quantity"
                          rules={[
                            {
                              required: true,
                              message: 'Please enter your quantity!'
                            },
                            {
                              type: 'number',
                              min: 1,
                              message: `Must be greater than 0`
                            },
                            {
                              type: 'number',
                              max: props.quantityStock,
                              message: `Disposal quantity must be equal to or less than available quantity`
                            }
                          ]}
                        >
                          <InputNumber
                            disabled={!!props.quantityStock ? false : true}
                          />
                        </Form.Item>
                      </>
                    ) : (
                      <>
                        {props.listCheckProduct?.map(
                          (item: any, index: any) => {
                            return (
                              <Form.Item
                                name={['quantity', index]}
                                label={`Quantity ${item.productName}`}
                                rules={[
                                  {
                                    required: true,
                                    message: 'Please input this!'
                                  },
                                  {
                                    type: 'number',
                                    max: item.unAvailableQuantity,
                                    message: `Disposal quantity must be equal to or less than unavailable quantity`
                                  },
                                  {
                                    type: 'number',
                                    min: 1,
                                    message: `Must be greater than 0`
                                  }
                                ]}
                              >
                                <InputNumber
                                  key={index}
                                  className={index.toString()}
                                />
                              </Form.Item>
                            );
                          }
                        )}
                      </>
                    )}
                  </Col>
                )}
                <Col span={7}>
                  <Form.Item
                    label="Reason for return/disposal "
                    name="reason"
                    rules={[
                      {
                        required: true,
                        message: 'Please select your reason!'
                      }
                    ]}
                  >
                    <Select
                      defaultValue={props.returnReason ?? 'Select'}
                      onChange={() => {
                        if (props.onChange) {
                          props.onChange(form);
                        }
                      }}
                    >
                      <Option value="Defective Stock">Defective Stock</Option>
                      <Option value="Short-selling Stock">
                        Short-selling Stock
                      </Option>
                      <Option value="Others">Others</Option>
                    </Select>
                  </Form.Item>
                </Col>
                {!props.canUpdate ? null : (
                  <>
                    {props?.screenName === 'ReturnImportDetail' ||
                    props?.screenName === 'ReturnStockDetail' ? (
                      <>
                        <Col span={7}>
                          <Form.Item
                            label={props.statusTitle}
                            name="statusReturn"
                            className="recipient-name"
                          >
                            <Input readOnly style={{ textAlign: 'center' }} />
                          </Form.Item>
                        </Col>
                      </>
                    ) : (
                      <>
                        {props.screenName !== 'ReturnDisposalDetail' ? (
                          <Col span={4}>
                            <Form.Item
                              label={'반품 상태'}
                              name="statusReturn"
                              className="recipient-name"
                            >
                              <Input readOnly style={{ textAlign: 'center' }} />
                            </Form.Item>
                          </Col>
                        ) : null}
                        <Col span={4}>
                          <Form.Item
                            label={
                              props.screenName === 'ReturnDisposalDetail'
                                ? '폐기 상태'
                                : '검수 상태'
                            }
                            name="warehouseReturnStatus"
                            className="recipient-name"
                          >
                            <Input disabled style={{ textAlign: 'center' }} />
                          </Form.Item>
                        </Col>
                      </>
                    )}
                  </>
                )}
              </Row>
            </Col>
          </Row>
          <div className="tag-button">

            {props.canUpdate ? null : (
                  <div className="button-container">
                    <Button
                      htmlType="submit"
                      onClick={() => {
                        setProcessType(ProcessType.Return);
                      }}
                      type="default"
                    >
                      {props?.RequestTitle ?? '반품 요청'}
                    </Button>
                  </div>
            )}
            {props.isCancelBtn ? (
                  <div className="button-container">
                    <Button
                      htmlType="submit"
                      className='button-submit'
                      onClick={() => {
                        setProcessType(ProcessType.Disposal);
                      }}
                      type="default"
                    >
                      폐기요청
                    </Button>
                  </div>
            ) :null}
          </div>
        </Form>
      ) : (
        <Form
          form={form}
          layout="vertical"
          className="recipient"
          style={{ padding: '19px 0px', marginBottom: '10px' }}
          ref={inputRef}
          initialValues={initialValues}
        >
          <Row>
            <Col span={11}>
              <Row>
                <Col span={12} style={{ paddingRight: '10px' }}>
                  <Form.Item
                    label="Recipient Name"
                    name="recipientName"
                    className="recipient-name"
                  >
                    <Input className="border-input" disabled />
                  </Form.Item>
                </Col>
                <Col span={12}>
                  <Form.Item
                    label="Recipient Phone Number"
                    name="recipientPhone"
                    className="recipient-name"
                  >
                    <Input className="border-input" disabled />
                  </Form.Item>
                </Col>
              </Row>
            </Col>
            <Col span={13} style={{ paddingLeft: '10px' }}>
              <Row>
                <Col span={24} style={{ padding: '8px 0px 8px' }}>
                  Shipping Country/Address
                </Col>
                <Col span={6} style={{ flex: '0 0 25%', paddingRight: '10px' }}>
                  <Form.Item name="country" className="recipient-name">
                    <Input disabled />
                  </Form.Item>
                </Col>
                <>
                  <Col span={18}>
                    <Form.Item
                      className="recipient-name"
                      name="shippingAddress"
                    >
                      <Input disabled />
                    </Form.Item>
                  </Col>
                </>
              </Row>
            </Col>
          </Row>
          <Row>
            <Col span={11} className="cmtArea">
              <div>
                <p>Comment from seller</p>
                <Form.Item name="sellerComment" className="recipient-name">
                  <TextArea rows={4} disabled style={{ resize: 'none' }} />
                </Form.Item>
              </div>
            </Col>
            <Col span={13} style={{ paddingLeft: '10px' }}>
              <Row
                style={{
                  marginTop: '21px'
                }}
              >
                <Col span={12}>
                  <Form.Item
                    name="detailReturnAddress2"
                    className="recipient-name"
                    style={{ padding: '0 5px 5px 0' }}
                  >
                    <Input disabled />
                  </Form.Item>
                </Col>
                <Col span={12}>
                  <Form.Item
                    name="detailReturnAddress"
                    className="recipient-name"
                  >
                    <Input disabled />
                  </Form.Item>
                </Col>
                <Col span={8}>
                  <Form.Item
                    name="city"
                    className="recipient-name"
                    style={{ padding: '0 5px 5px 0' }}
                  >
                    <Input disabled />
                  </Form.Item>
                </Col>
                <Col span={8}>
                  <Form.Item name="state" className="recipient-name">
                    <Input disabled />
                  </Form.Item>
                </Col>
                <Col span={8}>
                  <Form.Item
                    name="postalCode"
                    className="recipient-name"
                    style={{ padding: '0 0 0 5px' }}
                  >
                    <Input disabled />
                  </Form.Item>
                </Col>
              </Row>
              <Row style={{ gap: '10px', marginTop: '21px' }}>
                {props.notQuan ? null : (
                  <Col span={6}>
                    {props.haveOneQuan ? (
                      <>
                        <Form.Item label="Quantity" name="quantity">
                          <InputNumber disabled />
                        </Form.Item>
                      </>
                    ) : (
                      <>
                        {props.productReturn?.map(
                          (item: any, index: number) => (
                            <Form.Item
                              label={`Quantity ${item.productName}`}
                              name="{['quantity', index]}"
                              className="recipient-name"
                              rules={[
                                {
                                  type: 'number',
                                  min: 1,
                                  message: `Must be greater than 0`
                                }
                              ]}
                            >
                              <Input
                                disabled
                                defaultValue={item.returnQuantity}
                              />
                            </Form.Item>
                          )
                        )}
                      </>
                    )}
                  </Col>
                )}
                <Col span={7}>
                  <Form.Item
                    label="Reason for return/disposal"
                    name="returnReason"
                    className="recipient-name"
                  >
                    <Input disabled />
                  </Form.Item>
                </Col>
                {props.nothaveBtn ? null : (
                  <>
                    {props?.screenName === 'ReturnImportDetail' ||
                    props?.screenName === 'ReturnStockDetail' ? (
                      <>
                        <Col span={7}>
                          <Form.Item
                            label={props.statusTitle}
                            name="statusReturn"
                            className="recipient-name"
                          >
                            <Input disabled style={{ textAlign: 'center' }} />
                          </Form.Item>
                        </Col>
                      </>
                    ) : (
                      <>
                        {props.screenName !== 'ReturnDisposalDetail' ? (
                          <Col span={4}>
                            <Form.Item
                              label={'반품 상태'}
                              name="statusReturn"
                              className="recipient-name"
                            >
                              <Input disabled style={{ textAlign: 'center' }} />
                            </Form.Item>
                          </Col>
                        ) : null}
                        <Col span={4}>
                          <Form.Item
                            label={
                              props.screenName === 'ReturnDisposalDetail'
                                ? '폐기 상태'
                                : '검수 상태'
                            }
                            name="warehouseReturnStatus"
                            className="recipient-name"
                          >
                            <Input disabled style={{ textAlign: 'center' }} />
                          </Form.Item>
                        </Col>
                      </>
                    )}
                  </>
                )}
              </Row>
            </Col>
          </Row>
        </Form>
      )}
    </div>
  );
});
export default Recipient;
